<script setup lang="ts">
import type { LinkNavTab } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationLinkTabs } from '@shared/ui/menus'

defineOptions({
  name: 'SettingsMenu',
})

const route = useRoute()

const config = computed<LinkNavTab[]>(() => [
  {
    text: 'Settings',
    to: AppRoute.Settings,
    selected: route.path === AppRoute.Settings,
    disabled: false,
    visible: true,
  },
  {
    text: 'Experiments',
    to: AppRoute.SettingsExperiments,
    selected: route.path === AppRoute.SettingsExperiments,
    disabled: false,
    visible: true,
  },
])
</script>

<template>
  <NavigationLinkTabs :config="config" />
</template>
